import { render, staticRenderFns } from "./edit-credit-transfer.vue?vue&type=template&id=165e3e1c&scoped=true&"
import script from "./edit-credit-transfer.vue?vue&type=script&lang=js&"
export * from "./edit-credit-transfer.vue?vue&type=script&lang=js&"
import style0 from "./edit-credit-transfer.vue?vue&type=style&index=0&id=165e3e1c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "165e3e1c",
  null
  
)

export default component.exports